import { render, staticRenderFns } from "./TransportNew.vue?vue&type=template&id=2f8eed90"
import script from "./TransportNew.vue?vue&type=script&lang=js"
export * from "./TransportNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports